import './FindUs.css';

// Import your own images

// Location data with imported images
const locations = [
  {
    name: "Broumanna Location",
    address: "Mrah Ghanem Facing Tonino",
    googleMapsUrl: "https://share.google/u7UoHSf4ixWQKx7zR",
    image: "/broumannalocation.jpg",
  },
  {
    name: "Mansourieh Location",
    address: "Mansourieh Main Road after Abou Abdo to the right",
    googleMapsUrl: "https://maps.app.goo.gl/i5qNeUowCbU2h1zH6?g_st=am",
    image: "/mansouriehlocation.jpg",
  },
];

const FindUs = () => {
  return (
    <div className="app__findus">
      <div className="app__findus-header">
        <h1 className="findus__title">Find Us</h1>
      </div>
      <div className="app__findus-locations">
        <div className="findus__grid">
          {locations.map((location, index) => (
            <div key={index} className="findus__location">
              <a
                href={location.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="findus__box"
              >
                <img src={location.image} alt={`${location.name} `} className="findus__image" />
                <h2 className="findus__location-title">{location.name}</h2>
                <p className="findus__name">{location.address}</p>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FindUs;